import React from 'react';
import Grid from '@material-ui/core/Grid'
import { SelectInput, TextInput, required } from 'react-admin';

const EventGroupFields = props => (
  <React.Fragment>
    <Grid item xs={12} sm={6} >
      <TextInput source="name" validate={required()} {...props} />
    </Grid>
  </React.Fragment>
)

export default EventGroupFields